import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { IoArrowDownOutline, IoArrowForward } from "react-icons/io5";

interface ExpandIconProps {
  expanded: boolean;
}

const ExpandIcon: React.FC<ExpandIconProps> = ({ expanded }) => {
  return (
    <div className="inline-flex items-center justify-center w-4 h-4">
      <AnimatePresence mode="wait" initial={false}>
        {expanded ? (
          <motion.span
            key="open"
            initial={{ rotate: -90, opacity: 0, scale: 0.8 }}
            animate={{ rotate: 0, opacity: 1, scale: 1 }}
            exit={{ rotate: 90, opacity: 0, scale: 0.8 }}
            transition={{ duration: 0.15 }}
            className="inline-block"
          >
            <IoArrowDownOutline />
          </motion.span>
        ) : (
          <motion.span
            key="closed"
            initial={{ rotate: -90, opacity: 0, scale: 0.8 }}
            animate={{ rotate: 0, opacity: 1, scale: 1 }}
            exit={{ rotate: 90, opacity: 0, scale: 0.8 }}
            transition={{ duration: 0.15 }}
            className="inline-block"
          >
            <IoArrowForward />
          </motion.span>
        )}
      </AnimatePresence>
    </div>
  );
};

export default ExpandIcon;
